import {
  getProjectsSucceed,
  getProjectsFailure,
  updateProjectSucceed,
  updateProjectFailure
} from '../actions';
import {
  getProjects as getProjectsApi,
  updateProject as updateProjectApi
} from 'common/services/projects.service';

export const getProjects = () => async dispatch => {
  try {
    const projects = await getProjectsApi();
    dispatch(getProjectsSucceed(projects));
    return projects;
  } catch (e) {
    dispatch(getProjectsFailure([]));
  }
};

export const updateProject =
  (selectedTeamProjectId, payload) => async dispatch => {
    try {
      const project = await updateProjectApi(selectedTeamProjectId, payload);
      dispatch(updateProjectSucceed(project));
      return project;
    } catch (e) {
      dispatch(updateProjectFailure([]));
      return e;
    }
  };
